import React from "react";
import ReactQuill, { Quill } from "react-quill";
import ImageUploader from "quill-image-uploader";
Quill.register("modules/imageUploader", ImageUploader);
const ReactQuil = ({
  Form,
  name,
  labelName,
  restField,
  value,
  readOnly = false,
}) => {
  return (
    <Form.Item
      {...restField}
      name={name}
      label={`${labelName}`}
      initialValue=""
    >
      <ReactQuill
        readOnly={readOnly}
        style={{ height: "150px", marginBottom: "40px" }}
        modules={{
          toolbar: [
            [
              "bold",
              "italic",
              "link",
              "underline",
              "strike",
              "blockquote",
              "list",
              "bullet",
            ],
          ],
        }}
        formats={[
          "header",
          "bold",
          "italic",
          "underline",
          "strike",
          "blockquote",
          "list",
          "bullet",
          "indent",
          "link",
          "imageBlot",
        ]}
      />
    </Form.Item>
  );
};

export default ReactQuil;
